export const TemplateLocations = {
  ESOPHAGUS: 'Esophagus',
  STOMACH: 'Stomach',
  DUODENUM: 'Duodenum',
  UNASSIGNED: 'Unassigned',
  PREFACE: 'Preface',
  SUGGESTION: 'Suggestion',
  OTHER: 'Other',
};
